import { Base } from "../shared/base"

import { Reward } from '../reward/reward.model'

export class PathReward extends Base {

  init() {
    this._fields = ['id', 'pathId', 'starts', 'expires', 'enabled', 'reward']

    this._nestedFields = ['reward']
  }

  public id: number
  public pathId: number
  public starts: string
  public expires: string
  public enabled: boolean
  public reward: Reward
}
